import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { resetOfferAndNotify } from 'helpers/resetOfferAndNotify';
import Cookies from 'js-cookie';
import CarouselContainer from '../../containers/carousel';
import HeaderContainer from '../../containers/header';
// import HowWorkSection from '../../containers/howWorks';
import WinnerSection from '../../containers/winners';
import FaqSection from '../../containers/faqs';
import ParticipatesSection from '../../containers/participates';
import NewsLetterContainer from '../../containers/newsletter';
import FooterContainer from '../../containers/footer';
import BannerPromotionContainer from '../../containers/bannerPromotion';

const HomePage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const paramToken = url.searchParams.get('ssoToken');

    const urlRedirect = Cookies.get('redirect');
    if (paramToken !== null && urlRedirect !== '') {
      window.location.href = `${window.location.origin}/#/${urlRedirect}`;
      Cookies.remove('redirect');
    }
    if (paramToken !== null && urlRedirect === undefined) {
      window.location.href = `${window.location.origin}/`;
    }
    resetOfferAndNotify(dispatch);
  }, []);
  return (
    <>
      <HeaderContainer />
      <CarouselContainer />
      <Container fluid>
        <Row className="justify-content-center pt-60 bg-white">
          <Col lg={12}>
            <p className="text-center pb-15 text-tangaroa">
              Atrévete a descubrir todo lo que puedes ganar con Subastas Aeroméxico Rewards.
            </p>
          </Col>
        </Row>
      </Container>
      {/* <HowWorkSection
        backgroundColor="bg-white" /> */}
      <ParticipatesSection />
      <WinnerSection />
      <FaqSection />
      <BannerPromotionContainer />
      <NewsLetterContainer />
      <FooterContainer />
    </>
  );
};

export default HomePage;
